import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// Middleware
import AuthHandler from "./utils/AuthHandler";
import ProtectedRoute from "./components/ProtectedRoute";

// No Auth Pages
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Landing from "./pages/Landing";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import ViewProduct from "./pages/ViewProduct";

// Shared Pages
import Home from "./pages/shared/Home";
import Profile from "./pages/shared/Profile";
import Product from "./pages/shared/Product";
import VerifyEmail from "./pages/shared/VerifyEmail";
import Unsubscribe from "./pages/shared/Unsubscribe";
import Documentation from "./pages/shared/Documentation";

// User Pages
import BuyerProductForm from "./pages/forms/BuyerProductForm";
import SellerProductForm from "./pages/forms/SellerProductForm";
import ProductExplorer from "./pages/shared/ProductExplorer";

// Agent Pages
import ManageProducts from "./pages/agents/ManageProducts";
import RegisterClient from "./pages/agents/RegisterClient";

// Admin Routes
import AdminRoutes from "./pages/admin/AdminRoutes";

function App() {
  return (
    <BrowserRouter>
      <AuthHandler />

      <Routes>
        {/* No Auth */}
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/terms-of-use" element={<Terms />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path="/unsubscribe" element={<Unsubscribe />} />
        <Route path="/requests/:type/:id" element={<ViewProduct />} />

        {/* Shared */}
        <Route
          path="/home"
          element={
            <ProtectedRoute allowedRoles={["*"]}>
              <Home />
            </ProtectedRoute>
          }
        />

        <Route
          path="/profile"
          element={
            <ProtectedRoute allowedRoles={["*"]}>
              <Profile />
            </ProtectedRoute>
          }
        />

        <Route
          path="/product"
          element={
            <ProtectedRoute allowedRoles={["*"]}>
              <Product />
            </ProtectedRoute>
          }
        />

        {/* User */}
        <Route
          path="/buyer-form"
          element={
            <ProtectedRoute allowedRoles={["buyer", "buyer_agent"]}>
              <BuyerProductForm />
            </ProtectedRoute>
          }
        />

        <Route
          path="/seller-form"
          element={
            <ProtectedRoute allowedRoles={["seller", "seller_agent"]}>
              <SellerProductForm />
            </ProtectedRoute>
          }
        />

        <Route
          path="/products"
          element={
            <ProtectedRoute allowedRoles={["buyer", "seller"]}>
              <ProductExplorer />
            </ProtectedRoute>
          }
        />

        {/* Agent */}
        <Route
          path="/requests"
          element={
            <ProtectedRoute allowedRoles={["buyer_agent", "seller_agent"]}>
              <ManageProducts />
            </ProtectedRoute>
          }
        />

        <Route
          path="/register"
          element={
            <ProtectedRoute allowedRoles={["buyer_agent", "seller_agent"]}>
              <RegisterClient />
            </ProtectedRoute>
          }
        />

        <Route
          path="/documentation"
          element={
            <ProtectedRoute
              allowedRoles={["buyer_agent", "seller_agent", "admin"]}
            >
              <Documentation />
            </ProtectedRoute>
          }
        />

        {/* Admin */}
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <AdminRoutes />
            </ProtectedRoute>
          }
        />

        {/* Verify Email */}
        <Route path="/verify" element={<VerifyEmail />} />

        {/* 404 */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
